var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWindDirWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.55
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1894 2.22226L9.6469 6.57689L8.35249 6.57689V6.14679C8.35249 5.75303 8.03329 5.43383 7.63953 5.43383C7.24577 5.43383 6.92657 5.75303 6.92657 6.14679V6.57689L0.645358 6.57689C0.288937 6.57689 0 6.86583 0 7.22225C0 7.57867 0.288938 7.86761 0.64536 7.86761H6.92657V14.7131H6.43848C6.21757 14.7131 6.03848 14.8922 6.03848 15.1131V15.8804C6.03848 16.1013 6.21757 16.2804 6.43848 16.2804H8.86528C9.08619 16.2804 9.26528 16.1013 9.26528 15.8804V15.1131C9.26528 14.8922 9.08619 14.7131 8.86528 14.7131H8.35249V7.86761H16.6871C17.2718 7.86761 17.7657 7.47882 17.9244 6.94567H18V4.56016C18 3.03579 16.7643 1.80005 15.2399 1.80005C14.8484 1.80005 14.472 1.95132 14.1894 2.22226Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindDirWhite);
export default __webpack_public_path__ + "static/media/wind-dir-white.9a689ffd.svg";
export { ForwardRef as ReactComponent };